import React from 'react';
import { connect } from 'react-redux';
import { getProgressBar } from '../../../Utils/Utils';
import { objGraphsBarHtmlStyles } from './ObjGraphsBarHtmlCss';

//= ============================================================================
class ObjGraphsBarHtml extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const optionsCat1 = this.props.optionsCat1;
    let optionsArray;
    try {
      optionsArray = JSON.parse(optionsCat1);
    } catch (e) {}
    const sum = this.props.data.reduce(
      (sum, elem, arr) => sum + parseInt(elem.result),
      0
    );

    // Trier les données selon optionsArray si disponible
    const sortedData = [...this.props.data].sort((a, b) => {
      const keyA = Object.keys(a)?.find((key) => key !== 'result');
      const keyB = Object.keys(b)?.find((key) => key !== 'result');

      const valueA = a[keyA];
      const valueB = b[keyB];

      if (optionsArray && Array.isArray(optionsArray)) {
        const indexA = optionsArray.findIndex((opt) => opt.value === valueA);
        const indexB = optionsArray.findIndex((opt) => opt.value === valueB);

        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
      }

      // fallback : tri alphabétique
      return valueA.toString().localeCompare(valueB.toString());
    });

    return (
      <div style={objGraphsBarHtmlStyles.container}>
        {sortedData.map((elem, ind) => {
          const value =
            sum > 0 ? `${Math.round((elem.result / sum) * 100)}%` : `${0}%`;
          const key = Object.keys(elem)?.find((key) => key !== 'result');
          let colorToUse = '#228BE6';
          let iconToUse;
          let displayToUse = elem[key];
          if (optionsArray && Array.isArray(optionsArray)) {
            const option = optionsArray?.find(
              (elemIn) => elemIn.value === elem[key]
            );
            if (option) {
              colorToUse = option.color ?? colorToUse;
              iconToUse = option.icon;
              displayToUse = option.display ?? displayToUse;
            }
          }

          return getProgressBar(
            value,
            displayToUse,
            colorToUse,
            '',
            this.props.mini ? 12 : 12,
            iconToUse
          );
        })}
      </div>
    );
  }
}

//-----------------------------------------------------------------------------------------------------------

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ObjGraphsBarHtml);
